/* eslint-disable max-len */
import gqlRequest from 'graphql/generic';
import { AccountingFilter } from 'v2-types/order';

type addChargeReturn = {
  createOrderLedgerEntry: {
    _id: string
  };
};

const mutation = `
mutation CreateOrderLedgerEntry($id: ID!, $amount: Float!, $code: OrderLedgerCodes!, $description: String!, $kind: OrderLedgerKinds!, $entryDate: String, $letter:OrderLedgerCharges, $number: Int, $months: Int, $months_advanced: Int, $annuality: Float  $filters: OrderFilters) {
  createOrderLedgerEntry(_id: $id, amount: $amount, code: $code, description: $description, kind: $kind, entry_date: $entryDate,letter: $letter,  number: $number, months: $months,months_advanced: $months_advanced, annuality: $annuality, filters: $filters) {
    _id
  }
}
`;
type manualchargeParams = {
  id: string;
  entryDate: string | null;
  description: string;
  code: string;
  amount: number;
  letter: string | null;
  kind: string;
  number?: number | null;
  months?: number | null;
  months_advanced?: number | null;
  annuality?: number | null;
  filters?: { [key: string]: AccountingFilter };
};

export const addManualCharge = (params: manualchargeParams) =>
  gqlRequest<addChargeReturn, manualchargeParams>(mutation, params);

export default {};
